export default "__VITE_ASSET__DJ6wbibZ__";